import { Modal, Select, Button } from "@mantine/core";
import { useEffect, useState } from "react";
import { api } from "../services/master.service";

export default function DeliveryTimeModal({ opened, onClose, onSubmit }) {
  const [options, setOptions] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // Fetch delivery time list (GET)
  const getTimeVariant = async () => {
    try {
      const res = await api.get_delivery_time_variants(); // ADJUST FUNCTION NAME IF NEEDED
      if (res.data.success) {
        const arr = res.data.data.sort((a, b) => a.timevarient.localeCompare(b.timevarient)).map((item) => ({
          value: item.id.toString(),   // id
          label: item.timevarient,     // time text
        }));
        setOptions(arr);
      }
    } catch (error) {
      console.log("Error loading time variant", error);
    }
  };

  useEffect(() => {
    if (opened) {
      getTimeVariant();
      setSelectedId(null);
    }
  }, [opened]);

  const handleSubmit = () => {
    if (!selectedId) return;

    onSubmit(selectedId); // send only id
  };

  return (
     <Modal
  opened={opened}
  onClose={onClose}
  title="Required Delivery Time-On Delivery Day"
  centered
  size="md"
  styles={{
    body: {
      padding: 10,
      overflow: "visible",
    },
  }}
>
  <div style={{ maxHeight: "60vh", overflowY: "auto" }}>   {/* KEY FIX */}
    <Select
      searchable
      label="Delivery Time"
      placeholder="Select time"
      data={options}
      value={selectedId}
      onChange={setSelectedId}
      withinPortal={true}   // IMPORTANT
      dropdownPosition="bottom"
      maxDropdownHeight={200}
      styles={{
        dropdown: {
          zIndex: 99999,
        },
      }}
    />

    <Button
      mt={15}
      fullWidth
      color="green"
      onClick={handleSubmit}
    >
      Continue
    </Button>
  </div>
</Modal>

  );
}
